import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'bb-showcase-web',
  templateUrl: './showcase-web.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseWebComponent {}
